import { MessageSquareText } from "lucide-react";
import { SMS_PAY_NUMBER } from "../../config/site";

export const SmsBanner = () => {
  return (
    <section
      data-testid="sms-invite-banner"
      className="bg-[#0a1128] border-y border-[#eec643]/25"
    >
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8">
        <MessageSquareText className="text-[#eec643] shrink-0" size={26} />
        <div className="space-y-1">
          <p className="text-sm font-bold text-stone-100">
            Text <span className="text-[#eec643]">JOIN</span> to{" "}
            <span className="text-[#eec643]">{SMS_PAY_NUMBER}</span>, then reply{" "}
            <span className="text-[#eec643]">YES</span> to confirm and activate ledger alerts and
            text-to-pay.
          </p>
          <p className="text-xs text-stone-400 leading-relaxed">
            BGNZN Institute SMS program. Message frequency varies. Msg &amp; data rates may apply.
            Reply STOP to cancel, HELP for help.{" "}
            <a href="/sms-program" className="text-[#eec643] hover:text-[#fbec5d] underline underline-offset-2">
              Program details
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default SmsBanner;
